import { inject as d, ref as a, onMounted as m, onBeforeUnmount as v } from "vue";
import { internalSelectionMenuBodyInjectionKey as s } from "./highrise1535.mjs";
import { drawerBodyInjectionKey as p } from "./highrise1088.mjs";
import { modalBodyInjectionKey as y } from "./highrise1166.mjs";
import { popoverBodyInjectionKey as j } from "./highrise1449.mjs";
import { on as B, off as b } from "./highrise632.mjs";
import _ from "./highrise628.mjs";
const i = "__disabled__";
function f(c) {
  const o = d(y, null), l = d(p, null), u = d(j, null), t = d(s, null), r = a();
  if (typeof document < "u") {
    r.value = document.fullscreenElement;
    const n = () => {
      r.value = document.fullscreenElement;
    };
    m(() => {
      B("fullscreenchange", document, n);
    }), v(() => {
      b("fullscreenchange", document, n);
    });
  }
  return _(() => {
    var n;
    const {
      to: e
    } = c;
    return e !== void 0 ? e === !1 ? i : e === !0 ? r.value || "body" : e : o != null && o.value ? (n = o.value.$el) !== null && n !== void 0 ? n : o.value : l != null && l.value ? l.value : u != null && u.value ? u.value : t != null && t.value ? t.value : e ?? (r.value || "body");
  });
}
f.tdkey = i;
f.propTo = {
  type: [String, Object, Boolean],
  default: void 0
};
export {
  f as useAdjustedTo
};
